<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        {{ title }}
        <span class="close" (click)="close()">
            <mat-icon>close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent">
    <div class="row">
        <form [formGroup]="form1">
            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> واحد اندازه گیری : </span>
                    <span (click)="reset_input(218)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class='wh-input' formControlName="weight_title" autocomplete="off"
                        (click)="load_services(218)" required readonly>
                    <input class='wh-input' formControlName="weight" autocomplete="off" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1">مقدار : </span>
                    <input class='wh-input' formControlName="amount" autocomplete="off" required currencyMask>
                </label>
            </div>

            <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
                style="padding-top: 1.5rem;">
                <button class="btn_pe" (click)="insert()" [disabled]="!form1.valid">
                    اضافه کردن
                </button>
            </div>


        </form>
    </div>
    <input class="pe1" [ngClass]="{en1:lang == 2}" style="width:100%" (keyup)="get_data(2)" name="search"
        [(ngModel)]="search" autocomplete="off">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;max-height: 10rem;'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll_bg mat_table_fa_without_scroll_bg not- pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}" [ngStyle]="lang == 2 && {direction:'ltr'}">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style="max-width:70px">
                    #
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:70px">{{ i+1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">واحد اندازه گیری</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" (click)="open_detaile(i,x.meter_cate2_id)">
                    <div>{{x.wharehouse_weight_title }}</div>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">مقدار</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" (click)="open_detaile(i,x.meter_cate2_id)">
                    <div> {{ x.meter_cate2_amount }}</div>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="operation">
                <mat-header-cell *matHeaderCellDef style='max-width:100px'>
                    <span *ngIf="lang == 1"> عملیات </span>
                    <span *ngIf="lang == 2">Operation</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style='max-width:100px'>
                    <span (click)="open_detaile(i,x.meter_cate2_id,x.wharehouse_material_title)"><i
                            class="fas fa-desktop icon"></i></span>
                    <span class="operation-icon" (click)="check_access(3,0,x.meter_cate2_id,0,1)"><i
                            class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
            <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
                (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
                class="cursor"></mat-row>
        </mat-table>
    </div>

</div>